<script>
import CustomerRatingItem from '../CustomerRatingItem/index.vue'
import { getProjectEvaluateList } from '~/api/project.api'
import { getCompanyEvaluateList } from '~/api/company.api'

export default {
  components: {
    CustomerRatingItem
  },
  props: {
    width: {
      type: Number,
      default: 0
    },
    sum: {
      default: 0,
      type: Number
    }
  },
  data() {
    return {
      EvaluateList: [],
      pageNo: 1,
      pageSize: 3
    }
  },
  created() {
    this.getEvaluateList()
  },
  methods: {
    getEvaluateList,
    currentChange
  }
}

function currentChange(val) {
  this.pageNo = val
  this.getEvaluateList(val)
}

async function getEvaluateList() {
  if (this.isLoading) return
  this.isLoading = true
  let res = ''
  if (this.$route.params.projectId) {
    res = await getProjectEvaluateList({
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      projectId: this.$route.params.projectId
    })
  } else {
    res = await getCompanyEvaluateList({
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      companyId: this.$route.params.companyId
    })
  }

  if (res.length > 0) {
    this.EvaluateList = res
  }
  this.isLoading = false
}
</script>
<template>
  <ul class="project_rating_list_container">
    <li
      v-for="(evaluate, index) in EvaluateList"
      :key="index"
      class="project_rating_list_item_li_container"
    >
      <CustomerRatingItem :evaluate="evaluate" :width="width" />
    </li>
    <div v-if="sum > 3" class="pagination_container">
      <el-pagination
        :page-size="3"
        :total="sum"
        @current-change="currentChange"
        background
        layout="prev, pager, next"
      ></el-pagination>
    </div>
  </ul>
</template>
<style lang="scss">
.project_rating_list_container {
  padding: 0 !important;
  margin: 0 !important;
  * {
    margin: 0;
    padding: 0;
  }

  .project_rating_list_item_li_container {
    padding-top: 25px;
    display: flex;
    position: relative;
    // border: 1px solid red;
    // padding-bottom: 25px;
  }

  @media screen and (min-width: 940px) {
    .pagination_container {
      display: flex;
      justify-content: flex-end;
      text-align: right;
      padding-top: 30px;
    }
  }
}
</style>
